import React, { useContext, useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import DashboardIcon from './../../assets/img/home.svg';
import EmployeeIcon from './../../assets/img/employee.svg';
import InterviewIcon from './../../assets/img/interview-icon.png';
import CalenderIcon from './../../assets/img/calendar.svg';
import LeaveIcon from './../../assets/img/leave.svg';
import ReviewIcon from './../../assets/img/review.svg';
import SettingIcon from './../../assets/img/settings.svg';
import { LayoutContext } from '../../Context/LayoutContext';
import Skeleton from '../Common/Skeleton';

export default function NavigationBar() {
  const { setMobileMenuOpen, userInformation, currentUserRole } = useContext(LayoutContext);

  const [isSubMenuOpen, setIsSubMenuOpen] = useState('');

  const handleMouseOver = () => {
    if (document.body.classList.contains('mini-sidebar')) {
      document.body.classList.add('expand-menu');
    }
  };

  const handleMouseOut = () => {
    if (document.body.classList.contains('mini-sidebar')) {
      document.body.classList.remove('expand-menu');
    }
  };

  const toggleSubMenu = (menu) => {
    // e.preventDefault();
    setIsSubMenuOpen((prev) => (prev === menu ? '' : menu));
  };

  return (
    <div className="sidebar" id="sidebar">
      <div
        className="sidebar-inner slimscroll"
        onMouseOver={handleMouseOver}
        onMouseOut={handleMouseOut}
      >
        <div className="sidebar-contents">
          <div id="sidebar-menu" className="sidebar-menu">
            <div className="mobile-show">
              <div className="offcanvas-menu">
                <div className="user-info align-center bg-theme text-center">
                  <span
                    className="lnr lnr-cross  text-white"
                    id="mobile_btn_close"
                    onClick={() => {
                      setMobileMenuOpen(false);
                      document.documentElement.classList.remove('menu-opened');
                    }}
                  >
                    X
                  </span>
                  <Link to="#" className="d-block menu-style text-white">
                    <div className="user-avatar d-inline-block mr-3">
                      {userInformation?.ProfilePicture ? (
                        <img
                          src={`${userInformation?.ProfilePicture}`}
                          alt="user avatar"
                          className="rounded-circle"
                          width="50"
                        />
                      ) : (
                        <Skeleton height={'90px'} width={'90px'} radius={'50%'} />
                      )}
                    </div>
                  </Link>
                </div>
              </div>
              <div className="sidebar-input">
                <div className="top-nav-search">
                  <form>
                    <input type="text" className="form-control" placeholder="Search here" />
                    <button className="btn" type="submit">
                      <i className="fas fa-search"></i>
                    </button>
                  </form>
                </div>
              </div>
            </div>
            <ul className="parent-menu">
              <li>
                <NavLink to="/dashboard">
                  <img src={DashboardIcon} alt="sidebar_img" /> <span>Dashboard</span>
                </NavLink>
              </li>
              <li>
                <NavLink to="/leave">
                  <img src={LeaveIcon} alt="sidebar_img" /> <span>Leave Request</span>
                </NavLink>
              </li>
              <li>
                <NavLink to="/attendance-request">
                  <img src={ReviewIcon} alt="sidebar_img" />
                  <span>Attendance Request</span>
                </NavLink>
              </li>
              <li>
                <NavLink to="/calender">
                  <img src={CalenderIcon} alt="sidebar_img" /> <span>Calendar</span>
                </NavLink>
              </li>

              <li>
                <NavLink to="/employees">
                  <img src={EmployeeIcon} alt="sidebar_img" />
                  <span> Employees</span>
                </NavLink>
              </li>
              {currentUserRole !== 1 ? (
                <li>
                  <NavLink
                    to="/interview/list"
                    className={({ isActive }) =>
                      isActive || window.location.pathname.startsWith('/interview/') ? 'active' : ''
                    }
                  >
                    <img src={InterviewIcon} alt="sidebar_img" />
                    <span> Interview List</span>
                  </NavLink>
                </li>
              ) : (
                ''
              )}
              {currentUserRole === 1 ? (
                <li>
                  <NavLink
                    to="#"
                    className={() => (isSubMenuOpen === 'jobPost' ? 'active' : '')}
                    onClick={(e) => {
                      e.preventDefault();
                      toggleSubMenu('jobPost');
                    }}
                  >
                    <img src={EmployeeIcon} alt="sidebar_img" />
                    <span> Job Details</span>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <i className="fa fa-angle-down" aria-hidden="true"></i>
                  </NavLink>
                  <ul
                    className={`submenu ${isSubMenuOpen === 'jobPost' ? 'show' : ''}`}
                    style={{ paddingBottom: '10px', paddingTop: '10px' }}
                  >
                    <li>
                      <NavLink
                        to="/JobPost"
                        className={({ isActive }) => (isActive ? 'active' : '')}
                      >
                        Add New Job 
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        to="/JobList"
                        className={({ isActive }) => (isActive ? 'active' : '')}
                      >
                        Job List
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        to="/externalSME"
                        className={({ isActive }) => (isActive ? 'active' : '')}
                      >
                        Add External SME
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        to="/externalSMEList"
                        className={({ isActive }) => (isActive ? 'active' : '')}
                      >
                        External SME List
                      </NavLink>
                    </li>
                  </ul>
                </li>
              ) : null}
              {currentUserRole === 1 ? (
                <li>
                  <NavLink
                    to="#"
                    onClick={(e) => {
                      e.preventDefault();
                      toggleSubMenu('onBoarding');
                    }}
                    className={() => (isSubMenuOpen === 'onBoarding' ? 'active' : '')}
                  >
                    <img src={EmployeeIcon} alt="sidebar_img" />
                    <span> On Boarding</span>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <i className="fa fa-angle-down" aria-hidden="true"></i>
                  </NavLink>

                  {/* Sub-menu for Onboarding */}
                  <ul
                    className={`submenu ${isSubMenuOpen === 'onBoarding' ? 'show' : ''}`}
                    style={{ paddingBottom: '10px', paddingTop: '10px' }}
                  >
                    <li>
                      <NavLink to="/onboarding">Upload Resume</NavLink>
                    </li>
                    <li>
                      <NavLink to="/ResumeList">Resume List</NavLink>
                    </li>
                    <li>
                      <NavLink to="/InterviewPipeline">Interview Pipeline</NavLink>
                    </li>
                  </ul>
                </li>
              ) : (
                <></>
              )}
              {currentUserRole === 1 ? (
                <>
                  <li>
                    <NavLink to="/setting">
                      <img src={SettingIcon} alt="sidebar_img" />
                      <span>App Settings</span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/cms-setting">
                      <img src={SettingIcon} alt="sidebar_img" />
                      <span>CMS Settings</span>
                    </NavLink>
                  </li>
                </>
              ) : null}
              <li>
                <NavLink to="/reports">
                  <img src={SettingIcon} alt="sidebar_img" />
                  <span>Reports</span>
                </NavLink>
              </li>
            </ul>
            {/* <ul className="logout">
              <li>
                <Link to="#" onClick={handleLogout}>
                  <img src={LogoutIcon} alt="sidebar_img" />
                  <span>Log Out</span>
                </Link>
              </li>
            </ul> */}
          </div>
        </div>
      </div>
    </div>
  );
}
